<template>
  <div>
    <px-view-header title="Dashboard" title-class="font-weight-bold"
                    :breadcrumbs="breadcrumbs"/>
    <px-dashboard-header store="dashboard"/>
    <div v-if="loading">
      <px-circular-loading/>
    </div>
    <div v-else>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="6">
          <px-dashboard-totais-card :string-filter="stringFilter"
                                    :tipo-produto="tipoProduto"/>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="6">
          <px-dashboard-quantidade-compras :string-filter="stringFilter"
                                           :tipo-produto="tipoProduto"/>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" md="12" lg="6">
          <px-dashboard-quantidade-cotacoes :string-filter="stringFilter"
                                            :tipo-produto="tipoProduto"/>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="6">
          <px-dashboard-quantidade-requisicao :string-filter="stringFilter"
                                              :tipo-produto="tipoProduto"/>
        </v-col>
      </v-row>
      <v-row class="text-center align-center justify-center">
        <v-col cols="12" sm="12" md="12" lg="6">
          <px-dashboard-savings :string-filter="stringFilter"
                                :tipo-produto="tipoProduto"/>
        </v-col>
        <v-col cols="12" sm="12" md="12" lg="6">
          <px-dashboard-compras :string-filter="stringFilter"
                                :tipo-produto="tipoProduto"/>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import DashboardHeader from '@/modules/dashboard/DashboardHeader.vue';
import DashboardQuantidadeCompras from '@/modules/dashboard/DashboardQuantidadeCompras.vue';
import DashboardQuantidadeCotacoes from '@/modules/dashboard/DashboardQuantidadeCotacoes.vue';
import DashboardQuantidadeRequisicao from '@/modules/dashboard/DashboardQuantidadeRequisicao.vue';
import DashboardTotaisCard from '@/modules/dashboard/DashboardTotaisCard.vue';
import { mapGetters } from 'vuex';
import DashboardSavings from './DashboardSavings.vue';
import DashboardCompras from './DashboardCompras.vue';

export default {
  data() {
    return {
      loading: false,
      breadcrumbs: [
        { text: 'Indicadores' },
        { text: 'Dashboard' },
      ],
    };
  },
  computed: {
    ...mapGetters('dashboard', ['stringFilter', 'tipoProduto']),
  },
  components: {
    pxDashboardSavings: DashboardSavings,
    pxDashboardCompras: DashboardCompras,
    pxDashboardHeader: DashboardHeader,
    pxDashboardQuantidadeCompras: DashboardQuantidadeCompras,
    pxDashboardQuantidadeCotacoes: DashboardQuantidadeCotacoes,
    pxDashboardTotaisCard: DashboardTotaisCard,
    pxDashboardQuantidadeRequisicao: DashboardQuantidadeRequisicao,
  },
};
</script>
